import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { message } from 'antd';
import { getLoginUserInfo } from './College/apis/course';
import Admin  from './Admin/index';
import College from './College/index';
import HomePage from "./pages/home";

interface IProps {};
interface IState {
  isLoading: boolean;
};

class Secrity extends Component<IProps, IState> {
  state: IState = {
    isLoading: false
  }
  componentDidMount() {
    // const test = window.location.href;
    // if (test.indexOf("user_id") < 0) {
    //   window.location.href = redirectUrl;
    //   return;
    // }
    this.setState({
      isLoading: true
    })
    // let userid = test.split("?user_id=")[1];
    // if (userid) {
    //   const token = userid.split("&token=")[1].split("#/")[0];
    //   userid = userid.split("&token=")[0];
    //   localStorage.setItem('userId', JSON.stringify(userid)); //
    //   localStorage.setItem('token', JSON.stringify(token));
    //   this.getUserInfo(userid);
    // } else {
    //   window.location.href = redirectUrl;
    // }
  }
  // 获取用户信息
  getUserInfo = (id: any) => {
    let params = {
      user_id: id,
      id
    };
    getLoginUserInfo(params).then((res: any) => {
      if (res && res.code === 0) {
        localStorage.setItem('userinfo', JSON.stringify(res.data));
        this.setState({
          isLoading: true
        })
      } else {
        res && message.error(res.msg);
      }
    })
  }
  render() {
    const { isLoading } = this.state
    return isLoading &&
      <Switch>
        <Route exact path="/" component={HomePage}></Route>
        <Route path="/college" component={College}></Route>
        <Route path="/admin" component={Admin}></Route>
        <Redirect from="/" to="/college" />
      </Switch>
  }
}

export default Secrity;
